import { Empty, Typography } from 'antd'
import { ReactNode } from 'react'

interface EmptyCSVProps {
  children: ReactNode
}

function EmptyCSV({ children }: EmptyCSVProps) {
  return (
    <Empty
      description={
        <Typography.Text>
          Nothing here yet! Start by uploading a CSV file
        </Typography.Text>
      }
    >
      {children}
    </Empty>
  )
}

export default EmptyCSV
